import { loadTransaction, constants, filters } from 'lib_ui-services';
import { getLocationMerge } from './locationMerge';

export default {
    verb: 'doingFind',
    namespace: 'order',
    relation: 'order',
    description: 'Bring up a form to start, suspend, or close an order by scanning its order number',
    prerequisites: [
        {
            context: { verb: 'get', namespace: 'order', relation: 'order', type: 'find' },
            query: ({ data }) => {
                const { searchText } = data;
                const filter = filters.fullTextSearch.getMql({
                    fullTextSearch: { searchTerm: searchText },
                    propertiesToSearch: { propertiesToSearch: ['title'] },
                    caseSensitive: false,
                    exactMatchOnly: true,
                    preferLocal: true
                });
                return { ...filter, 'meta.deleted': { $exists: false } };
            }
        },
        {
            context: { verb: 'get', namespace: 'location', relation: 'location', type: 'get' },
            query: ({ data }) => ({ _id: data.locationId })
        }
    ],
    logic
};

async function logic({ data, context, prerequisiteResults, dispatch }) {
    const orderRecords = prerequisiteResults?.[0]?.result ?? [];
    const locationRecords = prerequisiteResults?.[1]?.result ?? [];

    if (orderRecords.length === 0) {
        dispatch(
            { message: `No order found matching '${data.searchText}'.`, variant: 'warning', type: constants.notificationTypes.TOAST },
            { verb: 'pop', namespace: 'application', relation: 'notification' }
        );
        return;
    }

    if (orderRecords.length > 1) {
        dispatch(
            { message: `Multiple orders found matching '${data.searchText}'.`, variant: 'warning', type: constants.notificationTypes.TOAST },
            { verb: 'pop', namespace: 'application', relation: 'notification' }
        );
        return;
    }

    const order = orderRecords[0];

    const location = locationRecords[0];
    if (!location) {
        dispatch(
            { message: 'No location selected. Please select a room first.', variant: 'warning', type: constants.notificationTypes.TOAST },
            { verb: 'pop', namespace: 'application', relation: 'notification' }
        );
        return;
    }

    const merge = getLocationMerge(order, location);
    const payload = merge ? { _id: order._id, ...merge } : { _id: order._id };

    await loadTransaction.create(
        async () => {
            await dispatch(
                payload,
                { ...context, verb: 'edit', namespace: 'order', relation: 'order' },
                true
            );
        },
        context,
        dispatch
    );
}
